import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { CALL_TYPE } from "~/constants/call";
import { useCallStore } from "~/stores/useCallStore";

const incomingSearchSchema = z.object({
  channel_id: z.string(),
  app_id: z.string(),
  rtc_channel_token: z.string(),
  rtm_channel_token: z.string().optional(),
  sender_id: z.string(),
  sender_name: z.string().catch(""),
  sender_avatar: z.string().optional(),
  sender_age: z.coerce.number().optional(),
  call_type: z.string().catch("video"),
});

export const Route = createFileRoute("/_authenticated/incoming")({
  validateSearch: incomingSearchSchema,
  beforeLoad: ({ search }) => {
    const { phase } = useCallStore.getState();

    if (phase.type !== "idle") {
      throw redirect({ to: "/" });
    }

    useCallStore.getState().setIncomingCallInfo({
      appId: search.app_id,
      rtcChannelToken: search.rtc_channel_token,
      rtmChannelToken: search.rtm_channel_token ?? null,
      channelId: search.channel_id,
    });

    useCallStore.getState().receiveCall(
      search.channel_id,
      {
        partnerId: search.sender_id,
        partnerName: search.sender_name,
        partnerAvatarUrl: search.sender_avatar ?? null,
        partnerAge: search.sender_age ?? null,
      },
      search.call_type === CALL_TYPE.VOICE ? CALL_TYPE.VOICE : CALL_TYPE.VIDEO,
    );

    throw redirect({ to: "/" });
  },
});
